import { ComponentProps } from "react";

const CheckRoundIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5627 7.51645C22.8707 6.31698 19.8631 6.01983 16.9884 6.66932C14.1138 7.31881 11.5261 8.88014 9.61131 11.1204C7.69651 13.3608 6.5572 16.16 6.36329 19.1007C6.16938 22.0415 6.93126 24.9661 8.53531 27.4384C10.1394 29.9108 12.4996 31.7984 15.2641 32.8197C18.0286 33.841 21.0491 33.9414 23.8753 33.1058C26.7015 32.2702 29.1818 30.5434 30.9464 28.1829C32.711 25.8225 33.6653 22.9549 33.667 20.0078V18.6285C33.667 17.8922 34.2639 17.2952 35.0003 17.2952C35.7367 17.2952 36.3337 17.8922 36.3337 18.6285V20.0085C36.3316 23.5307 35.1911 26.9586 33.0822 29.7796C30.9733 32.6006 28.009 34.6643 24.6314 35.663C21.2538 36.6617 17.6438 36.5417 14.34 35.3211C11.0361 34.1005 8.21526 31.8446 6.29823 28.8898C4.38119 25.9351 3.47065 22.4398 3.7024 18.9253C3.93414 15.4108 5.29576 12.0653 7.58418 9.38786C9.8726 6.71041 12.9652 4.84443 16.4008 4.06821C19.8363 3.29199 23.4308 3.64713 26.648 5.08064C27.3206 5.38035 27.6229 6.16858 27.3232 6.84121C27.0235 7.51384 26.2353 7.81616 25.5627 7.51645Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.9427 7.06535C36.4636 7.58579 36.464 8.43001 35.9436 8.95096L20.9436 23.966C20.6936 24.2162 20.3544 24.3569 20.0007 24.357C19.6469 24.357 19.3076 24.2166 19.0575 23.9664L14.5575 19.4664C14.0368 18.9457 14.0368 18.1015 14.5575 17.5808C15.0782 17.0601 15.9224 17.0601 16.4431 17.5808L19.9999 21.1375L34.057 7.06629C34.5775 6.54533 35.4217 6.54491 35.9427 7.06535Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckRoundIcon;
